import React from 'react';
import { Film, Award, Download, FileText } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

const Gaff2025 = () => {

  const asianCinema = [
    {
      id: 1,
      title: 'A Lab Story',
      director: 'Carlo Obispo',
      country: 'Philippines',
      language: 'Tagalog',
      runtime: "98'",
      poster: 'https://images.unsplash.com/photo-1440404653325-ab127d49abc1'
    },
    {
      id: 2,
      title: 'In The Arms of The Tree',
      director: 'Babak Khajehpasha',
      country: 'Iran',
      language: 'Persian',
      runtime: "82'",
      badge: 'Opening Film',
      poster: 'https://images.unsplash.com/photo-1485846234645-a62644f84728'
    },
    {
      id: 3,
      title: 'Shambhala',
      director: 'Min Bahadur Bham',
      country: 'Nepal',
      language: 'Tibetan, Nepali',
      runtime: "150'",
      poster: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4'
    },
    {
      id: 4,
      title: 'Captain',
      director: 'Mohammad Hamzei',
      country: 'Iran',
      runtime: "90'",
      poster: 'https://images.unsplash.com/photo-1519681393784-d120267933ba'
    },
    {
      id: 5,
      title: 'The Stranger',
      director: 'Biplob Sarkar',
      country: 'Bangladesh',
      runtime: "80'",
      poster: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470'
    },
    {
      id: 6,
      title: 'Not What You Think',
      director: 'Vuslat Saracoglu',
      country: 'Turkey',
      runtime: "107'",
      poster: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4'
    },
    {
      id: 7,
      title: 'House',
      director: 'Jamshid Narzikulov',
      country: 'Uzbekistan',
      runtime: "90'",
      poster: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e'
    },
    {
      id: 8,
      title: 'The Great Phuket',
      director: 'Liu Yaonam',
      country: 'Hong Kong',
      runtime: "97'",
      poster: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29'
    },
    {
      id: 9,
      title: 'Joqtau',
      director: 'Aruan Anartay',
      country: 'Kazakhstan',
      runtime: "70'",
      poster: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4'
    },
    {
      id: 10,
      title: 'A Road To A Village',
      director: 'Nabin Subba',
      country: 'Nepal',
      runtime: "106'",
      poster: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b'
    },
    {
      id: 11,
      title: 'Cold As Marble',
      director: 'Asif Rustamov',
      country: 'Azerbaijan',
      runtime: "88'",
      poster: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4'
    },
    {
      id: 12,
      title: 'Teach Me',
      director: 'Shyam Fernando',
      country: 'Sri Lanka',
      runtime: "100'",
      poster: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29'
    }
  ];

  const indianShowcase = [
    {
      id: 1,
      title: 'Level Cross',
      director: 'Arfaz Ayub',
      language: 'India',
      runtime: "120'",
      poster: 'https://images.unsplash.com/photo-1485846234645-a62644f84728'
    },
    {
      id: 2,
      title: 'Bahadur The Brave',
      director: 'Diwa Shah',
      language: 'India',
      runtime: "82'",
      poster: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4'
    },
    {
      id: 3,
      title: 'Celestina & Lawrence',
      director: 'Vikram Kumar',
      language: 'India',
      runtime: "112'",
      poster: 'https://images.unsplash.com/photo-1519681393784-d120267933ba'
    },
    {
      id: 4,
      title: 'In The Name of Fire',
      director: 'Abhilash Sharma',
      language: 'India',
      runtime: "98'",
      poster: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b'
    },
    {
      id: 5,
      title: 'Second Chance',
      director: 'Subhadra Mahajan',
      language: 'India',
      runtime: "104'",
      poster: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470'
    },
    {
      id: 6,
      title: 'The Light Within',
      director: 'Promita Bhowmik',
      language: 'India',
      runtime: "86'",
      poster: 'https://images.unsplash.com/photo-1440404653325-ab127d49abc1'
    }
  ];

  const neIndiaCompetition = [
    {
      id: 1,
      title: 'Amateurs',
      director: 'Dhiraj Kashyap',
      language: 'Assamese',
      runtime: "78'",
      poster: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4'
    },
    {
      id: 2,
      title: 'Ata Nirjon Duporiya',
      director: 'Khanjan Kishore Nath',
      language: 'Assamese',
      runtime: "102'",
      awards: ['Best Editing'],
      poster: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e'
    },
    {
      id: 3,
      title: 'Mirbeen',
      director: 'Mridul Gupta',
      language: 'Karbi',
      runtime: "89'",
      poster: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29'
    },
    {
      id: 4,
      title: 'Before Spring',
      director: 'Shrutismriti Changkakoti',
      language: 'Assamese',
      runtime: "86'",
      awards: ['Best Director', 'Best Performance', 'Best Cinematography', 'Best Sound Design'],
      poster: 'https://images.unsplash.com/photo-1485846234645-a62644f84728'
    },
    {
      id: 5,
      title: "Joseph's Son",
      director: 'Haobam Paban Kumar',
      language: 'Manipuri',
      runtime: "83'",
      awards: ['Best Film', 'Best Music'],
      poster: 'https://images.unsplash.com/photo-1519681393784-d120267933ba'
    },
    {
      id: 6,
      title: 'Collage',
      director: 'Amardeep Gogoi',
      language: 'Assamese',
      runtime: "89'",
      awards: ['Best Screenplay'],
      poster: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b'
    }
  ];


  const awards = [
    { category: 'Best Film', winner: "Joseph's Son", director: 'Haobam Paban Kumar' },
    { category: 'Best Director', winner: 'Shrutismriti Changkakoti', film: 'Before Spring' },
    { category: 'Best Performance', winner: 'Deepjyoti Kakati', film: 'Before Spring' },
    { category: 'Best Music', winner: 'Rewben Mashangva', film: "Joseph's Son" },
    { category: 'Best Screenplay', winner: 'Amardeep Gogoi', film: 'Collage' },
    { category: 'Best Cinematography', winner: 'Jayanth Mathavan', film: 'Before Spring' },
    { category: 'Best Editing', winner: 'Rantu Chetia', film: 'Ata Nirjon Duporiya' },
    { category: 'Best Sound Design', winner: 'Kalesh Laxman & Bambi', film: 'Before Spring' }
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-7xl md:text-9xl font-bold mb-8 leading-tight">
              GAFF <span className="text-red-500">2025</span>
            </h1>
            <div className="w-24 h-1 bg-red-500 mx-auto mb-8"></div>
            <p className="text-xl text-gray-400">
              1st Edition • February 7-9, 2025
            </p>
            <p className="text-2xl font-bold mt-4">
              Cinema Beyond Borders
            </p>
            <p className="text-lg text-gray-400 mt-4">
              Inaugurated by internationally acclaimed Sri Lankan Filmmaker <span className="text-white font-semibold">Prasanna Vithanage</span> along with noted Indian Actor <span className="text-white font-semibold">Sheeba Chadha</span>
            </p>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-20 right-10 w-32 h-32 border-2 border-red-500/20 rounded-full"></div>
        <div className="absolute bottom-10 left-10 w-24 h-24 border-2 border-red-500/20 rounded-full"></div>
      </section>

      {/* Participating Countries Section */}
      <section className="py-20 bg-gradient-to-b from-black to-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-12">
              PARTICIPATING <span className="text-red-500">COUNTRIES</span>
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {[
                'Iran',
                'Uzbekistan',
                'Nepal',
                'Kazakhstan',
                'Bangladesh',
                'Hong Kong',
                'Philippines',
                'Sri Lanka',
                'Turkey',
                'Azerbaijan',
                'India'
              ].map((country, index) => (
                <div
                  key={index}
                  className="group relative p-6 bg-white/5 border border-white/10 rounded-lg hover:bg-red-500/10 hover:border-red-500/50 transition-all duration-300"
                  style={{
                    animation: `fadeInUp 0.6s ease-out ${index * 0.05}s both`
                  }}
                >
                  <p className="text-lg font-semibold group-hover:text-red-500 transition-colors">
                    {country}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Festival Catalogue Section */}
      <section className="relative bg-black text-white py-32">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-zinc-900 to-black border border-white/10 rounded-2xl p-12 relative overflow-hidden">
              {/* Decorative Elements */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/5 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-red-500/5 rounded-full blur-3xl"></div>
              
              <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                {/* Left Side - Icon/Illustration */}
                <div className="flex justify-center md:justify-start">
                  <div className="w-48 h-48 bg-red-500/10 rounded-2xl flex items-center justify-center border border-red-500/20">
                    <FileText size={80} className="text-red-500" />
                  </div>
                </div>

                {/* Right Side - Content */}
                <div>
                  <h3 className="text-3xl md:text-4xl font-bold mb-4">
                    FESTIVAL CATALOGUE
                  </h3>
                  <p className="text-gray-400 mb-2">
                    <span className="text-red-500 font-semibold">1st Edition • 2025</span>
                  </p>
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    Explore our complete festival programme featuring film synopses, director profiles, screening schedules, and special events from 2025 edition.
                  </p>
                  <a
                    href="https://drive.google.com/file/d/1EOV1hlrwvizsylTRrFE5aIEFb2Ev72Sr/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button 
                      size="lg"
                      className="bg-red-500 text-white hover:bg-red-600 transition-all duration-300 group"
                    >
                      <Download size={20} className="mr-2 group-hover:animate-bounce" />
                      Download Catalogue
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5 pointer-events-none">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}></div>
        </div>
      </section>

      {/* Awards Section */}
      <section className="py-20 bg-gradient-to-b from-black to-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-16">
              <Award size={48} className="text-yellow-500 mx-auto mb-4" />
              <h2 className="text-4xl md:text-5xl font-bold mb-4">
                AWARDS & RECOGNITION
              </h2>
              <p className="text-xl text-gray-400">
                North East India Film Competition
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {awards.map((award, index) => (
                <div
                  key={index}
                  className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-yellow-500/50 transition-all duration-300"
                  style={{
                    animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                  }}
                >
                  <div className="flex items-start gap-4">
                    <Award size={24} className="text-yellow-500 flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="text-xl font-bold mb-2 text-yellow-500">
                        {award.category}
                      </h3>
                      <p className="text-white font-semibold mb-1">{award.winner}</p>
                      {award.film && (
                        <p className="text-sm text-gray-400">Film: {award.film}</p>
                      )}
                      {award.director && (
                        <p className="text-sm text-gray-400">Dir. {award.director}</p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      
      {/* Panels Section */}
      <section className="py-20 bg-gradient-to-b from-black to-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-4">
                FESTIVAL PANELS
              </h2>
              <p className="text-xl text-gray-400">
                Jury Committee
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-1 gap-8 max-w-3xl mx-auto">
              {/* Jury Panel - NE India */}
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-6 text-red-500">
                  JURY PANEL
                </h3>
                <p className="text-sm text-gray-400 uppercase tracking-wider mb-4">
                  NE India Film Competition
                </p>
                <div className="space-y-3">
                  <div>
                    <p className="font-bold">Prasanna Vithanage</p>
                    <p className="text-sm text-gray-400">Chairperson | Sri Lanka</p>
                  </div>
                  <div>
                    <p className="font-bold">Dr Santwana Bordoloi</p>
                    <p className="text-sm text-gray-400">India</p>
                  </div>
                  <div>
                    <p className="font-bold">Akashaditya Lama</p>
                    <p className="text-sm text-gray-400">India</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <div className="text-5xl font-bold text-red-500 mb-2">
                  {asianCinema.length + indianShowcase.length + neIndiaCompetition.length}
                </div>
                <div className="text-sm uppercase tracking-widest text-gray-400">Total Films Screened</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <div className="text-5xl font-bold text-red-500 mb-2">{asianCinema.length}</div>
                <div className="text-sm uppercase tracking-widest text-gray-400">Asian Cinema</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <div className="text-5xl font-bold text-red-500 mb-2">{indianShowcase.length}</div>
                <div className="text-sm uppercase tracking-widest text-gray-400">Indian Showcase</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <div className="text-5xl font-bold text-red-500 mb-2">{neIndiaCompetition.length}</div>
                <div className="text-sm uppercase tracking-widest text-gray-400">NE Competition</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Gaff2025;
